import { render, staticRenderFns } from "./ProductsIndex.vue?vue&type=template&id=0d278dec&"
import script from "./ProductsIndex.vue?vue&type=script&lang=js&"
export * from "./ProductsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports